import { useIntl } from 'react-intl'
import NotFoundComponent from '../../../../../components/stories/molecules/not-found'
import {
  EmptyProjectTreeContainer,
  EmptyContent,
  EmptyProjectTreeButtonsContainer
} from '../../../styled-component'
import { Project } from '../../../../../components/stories/atoms/icons/entities'
import colorsOptions from '../../../../../components/stories/fundamentals/colors-styles/constants'
import ButtonComponent from '../../../../../components/stories/atoms/button'
import { buttonVariantOptions } from '../../../../../components/stories/atoms/button/constants'
import PropTypes from 'prop-types'
import { projectMenuTabOptions } from '../../../constants'
import { textStyleSizeOptions } from '../../../../../components/stories/fundamentals/text-styles/constants'

const ProjectMenuTileEmptyProjectTree = ({
  handleBackFolder = () => {},
  handleCreateProject = () => {},
  projectListOption = projectMenuTabOptions.MY_PROJECTS,
  isFolder = false,
  userPermissions
}) => {
  const { formatMessage } = useIntl()

  const canCreateProjects = userPermissions?.includes('CreateProjects')

  const isMyProjectList =
    projectListOption === projectMenuTabOptions.MY_PROJECTS

  const defineTitle = () => {
    if (isFolder) return 'this_folder_is_empty'
    if (isMyProjectList) {
      if (canCreateProjects) return 'no_projects_yet'
      return 'no_projects_yet_permission'
    }
    return 'no_org_projects'
  }

  const defineDescription = () => {
    if (isFolder) return 'this_folder_is_empty_description'
    if (isMyProjectList) {
      if (canCreateProjects) return 'no_projects_yet_description_permission'
      return 'no_projects_yet_description_no_permission'
    }
    return 'no_org_projects_description'
  }

  const title = defineTitle()
  const description = defineDescription()

  return (
    <EmptyProjectTreeContainer>
      <EmptyContent>
        <NotFoundComponent
          icon={
            <Project
              style={{ width: '144px', height: '144px' }}
              stroke={colorsOptions.greys['grey-50']}
            />
          }
          header={formatMessage({ id: title })}
          headerSize={textStyleSizeOptions['TEXT-XXL']}
          description={formatMessage({
            id: description
          })}
          descriptionSize={textStyleSizeOptions['TEXT-L']}
        />
        <EmptyProjectTreeButtonsContainer>
          {isFolder && (
            <ButtonComponent
              variant={buttonVariantOptions['TERTIARY-WHITE-FILL']}
              onClick={handleBackFolder}
            >
              {formatMessage({ id: 'back_to_parent_folder' })}
            </ButtonComponent>
          )}

          {canCreateProjects && (
            <ButtonComponent
              variant={buttonVariantOptions.PRIMARY}
              onClick={handleCreateProject}
            >
              {formatMessage({ id: 'create_project' })}
            </ButtonComponent>
          )}
        </EmptyProjectTreeButtonsContainer>
      </EmptyContent>
    </EmptyProjectTreeContainer>
  )
}

ProjectMenuTileEmptyProjectTree.propTypes = {
  handleBackFolder: PropTypes.func,
  handleCreateProject: PropTypes.func,
  projectListOption: PropTypes.string,
  isFolder: PropTypes.bool
}

export default ProjectMenuTileEmptyProjectTree
